import React from 'react';
import Modal from '../Modal2';
import _ from 'lodash';
import AssetListCache from '../../queries/asset/AssetListCache';
import t from '../../i18n/I18n';
import { Checkbox } from '../../common/form';
import { containsAnyFolder, filterAssets, isAnyNonProxyAsset, isAnyProxyAsset } from '../../util/SelectedItemUtil';
import { archiveResolutions, archiveStatusEnum, RESTORE_STATUS } from '../../util/Constants';
import { RestoreQuery } from '../../queries/archive-restore/RestoreQuery';
import { RepoItem } from '../../autogenerated/ZoomBridge';

type Props = {
  assets: Array,
  onClose: Function,
  onRefreshPWD: Function
};

export default class RestoreModal extends React.Component<Props> {
  _assetListCache: AssetListCache;
  resolution = [
    { label: archiveResolutions.HI_RES, isChecked: false, isVisible: false, isEnable: false },
    { label: archiveResolutions.MID_RES, isChecked: false, isVisible: false, isEnable: false },
    { label: archiveResolutions.LOW_RES, isChecked: false, isVisible: false, isEnable: false },
    { label: archiveResolutions.DIRECT, isChecked: false, isVisible: false, isEnable: false }
  ];
  constructor(props) {
    super(props);
  }

  state = { isLoaded: false };

  componentDidMount() {
    this.setOptions();
  }

  onToggle = (i) => {
    this.resolution[i].isChecked = !this.resolution[i].isChecked;
    this.forceUpdate();
  };

  returnCheckBoxStatusBasedOnArchiveStatus(status, resolution) {
   
    const resolutionObj = { enable: false, selected: false, visible: true };
    switch (resolution) {
      case archiveResolutions.HI_RES:
        if (status === archiveStatusEnum.VAB_COPIED_TO_ARCHIVE) {
          resolutionObj.enable = true;
          resolutionObj.selected = true;
        } 
        break;
      case archiveResolutions.MID_RES:
        if (status !== archiveStatusEnum.VAB_NOT_APPLICABLE) {
          resolutionObj.enable = true;
          if (status !== archiveStatusEnum.VAB_COPIED_TO_ARCHIVE) {
            resolutionObj.selected = true;
          }
        }
        break;
      case archiveResolutions.LOW_RES:
        if (status !== archiveStatusEnum.VAB_NOT_ARCHIVED) {
          resolutionObj.enable = true;
          resolutionObj.selected = true;
        } 
        break;
      case archiveResolutions.DIRECT:
        if (!status) {
          resolutionObj.enable = true;
          resolutionObj.selected = true;
        } else {
          resolutionObj.enable = true;
        }
        break;

      default:
        break;
    }
    if( status === archiveStatusEnum.VAB_NOT_APPLICABLE) {
      resolutionObj.visible = false;
    }
    return resolutionObj;
  }

  isStatusNotAvailableOnAllAssets(items, status) {
    for (const item of items) {
      if (item[status] != archiveStatusEnum.VAB_NOT_APPLICABLE) return false;
    }
    return true;
  }

  getAvailableStatus(assets, status) {
    if (this.isStatusNotAvailableOnAllAssets(assets, status)) {
      return { enable: false, selected: false, visible: false };
    } else {
      //checkbox visible is true
      if (this.isAnyArchiveOrPending(assets, status)) {
        return { enable: true, selected: true, visible: true };
      } else {
        return { enable: false, selected: false, visible: true };
      }
    }
  }

  isAnyArchiveOrPending(items, status, isLowResOrDirect) {
    for (const item of items) {
      if (
        isLowResOrDirect ||
        item[status] == archiveStatusEnum.VAB_COPIED_TO_ARCHIVE ||
        item[status] == archiveStatusEnum.VAB_ARCHIVED ||
        item[status] == archiveStatusEnum.VAB_PENDING
      )
        return true;
    }
    return false;
  }
  setOptions() {
    const { assets } = this.props;
    let hiRes = {},
      midRes = {},
      lowRes = {},
      direct = {};
    let directExecuteQuery = false;
    const anyFolder = containsAnyFolder(assets);
    if (anyFolder) {
      hiRes = { enable: true, selected: true, visible: true };
      midRes = lowRes = direct = { enable: true, selected: false, visible: true };
    } else if (assets.length === 1) {
      const item: RepoItem = assets[0];
      hiRes = this.returnCheckBoxStatusBasedOnArchiveStatus(item.getHiResArchiveStatus(), archiveResolutions.HI_RES);
      midRes = this.returnCheckBoxStatusBasedOnArchiveStatus(item.getMidResArchiveStatus(), archiveResolutions.MID_RES);
      if (item.isProxy()) {
        lowRes = this.returnCheckBoxStatusBasedOnArchiveStatus(
          item.getLowResArchiveStatus(),
          archiveResolutions.LOW_RES
        );
      } else {
        direct = this.returnCheckBoxStatusBasedOnArchiveStatus(item.isArchived(), archiveResolutions.DIRECT);
        directExecuteQuery = true;
      }
    } else {
      if (!isAnyProxyAsset(assets)) {
        directExecuteQuery = true;
      } else {
        hiRes = this.getAvailableStatus(assets, RESTORE_STATUS.HI_RES);
        midRes = this.getAvailableStatus(assets, RESTORE_STATUS.MID_RES);
        lowRes = this.getAvailableStatus(assets, RESTORE_STATUS.LOW_RES);

        if (isAnyNonProxyAsset(assets)) {
          direct = { enable: true, selected: false, visible: true };
        }
      }
    }

    if (directExecuteQuery) {
      direct = { enable: true, selected: false };
    }
    this.setResolutionOption(hiRes, midRes, lowRes, direct);
    this.setState({ isLoaded: true });

    if (directExecuteQuery) {
      this.restore();
    }
  }

  setResolutionOption(hiRes, midRes, lowRes, direct) {
    this.resolution[0].isChecked =
      hiRes.selected || (hiRes.enable && !midRes.enable && !lowRes.enable && !direct.enable);
    this.resolution[1].isChecked =
      midRes.selected || (midRes.enable && !hiRes.enable && !lowRes.enable && !direct.enable);
    this.resolution[2].isChecked =
      lowRes.selected || (lowRes.enable && !hiRes.enable && !midRes.enable && !direct.enable);
    this.resolution[3].isChecked =
      direct.selected || (direct.enable && !hiRes.enable && !midRes.enable && !lowRes.enable);

    this.resolution[0].isEnable = hiRes.enable;
    this.resolution[1].isEnable = midRes.enable;
    this.resolution[2].isEnable = lowRes.enable;
    this.resolution[3].isEnable = direct.enable;

    this.resolution[0].isVisible = hiRes.visible;
    this.resolution[1].isVisible = midRes.visible;
    this.resolution[2].isVisible = lowRes.visible;
    this.resolution[3].isVisible = direct.visible;
  }

  render() {
    const { onClose, assets } = this.props;
    const { isLoaded } = this.state;
    const isSubmitEnable = this.resolution.some((e) => e.isChecked);
    const modalProps = {
      name: 'RestoreModal',
      title: t('RESTORE_ASSET_TITLE'),
      onClose,
      buttons: [
        { label: t('CANCEL'), type: 'CANCEL', onClick: this.props.onClose },
        { label: t('RESTORE'), type: 'PRIMARY', disabled: !isSubmitEnable, onClick: () => this.restore() }
      ]
    };

    return (
      <Modal {...modalProps} closeOnEsc closeOnOutsideClick>
        <div>
          <div className="content m-2">
            {this.props.assets.length > 1
              ? t('RESTORE_MULTI_DIALOG_MSG', {
                  COUNT: this.props.assets.length
                })
              : t('SELECT_RESOLUTION')}
          </div>
          {isLoaded ? (
            <div className="d-flex">
              {this.resolution.map((e, i) => {
                return e.isVisible ? (
                  <div className="mr-4" key={`restore-item${i}`}>
                    <Checkbox
                      key={i}
                      label={e.label}
                      disabled={!e.isEnable}
                      checked={e.isChecked}
                      onChange={() => this.onToggle(i)}
                    />
                  </div>
                ) : null;
              })}
            </div>
          ) : null}
        </div>
      </Modal>
    );
  }

  restore() {
    const { assets } = this.props;
    let { assetIds } = filterAssets(assets, -1, false, true);
    const query = new RestoreQuery(
      this.resolution[0].isChecked,
      this.resolution[1].isChecked,
      this.resolution[2].isChecked,
      this.resolution[3].isChecked,
      assetIds
    );
    query.run(this.props.onRefreshPWD);
    this.props.onClose(true);
  }
}
const styles = {
  asset: {
    width: '100%',
    background: 'var(--primary-header-bg)',
    color: 'var(--primary-font-color)',
    padding: '5px',
    display: 'flex',
    boxShadow: '0 1px 4px 0 rgba(0,0,0,0.04)',
    cursor: 'pointer',
    fontSize: '14px',
    marginBottom: '15px'
  }
};
